module.exports = __webpack_public_path__ + "img/wolf-gold.19d62c45.png";